export default __webpack_public_path__ + "static/media/cryptofont-webfont.97e0ca34.eot";